import { toNumber } from 'lodash';
import { useMemo } from 'react';
import { getGridDimensionCalculations, parseLayoutConfig } from 'src/utils';

export const useGetScreenGridsInfo = (
  gridLines: string[],
  screenIndex: number,
  scale?: number,
) => {
  const screenGridLine = gridLines?.[toNumber(screenIndex)];

  const layoutConfigData = useMemo(
    () => (screenGridLine ? parseLayoutConfig(screenGridLine) : undefined),
    [screenGridLine],
  );

  const screenGridsData = useMemo(
    () =>
      layoutConfigData
        ? getGridDimensionCalculations({
            orientation: layoutConfigData?.orientation,
            disclaimerPosition: layoutConfigData?.disclaimerPosition,
            disclaimerType: layoutConfigData?.disclaimerType,
            rows: layoutConfigData?.rows,
            cols: layoutConfigData?.cols,
            scale,
          })
        : undefined,
    [layoutConfigData, scale],
  );

  return {
    ...(layoutConfigData ?? {}),
    ...(screenGridsData ?? {}),
  };
};
